var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import withBranding from "@irati/brand/withBranding";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import StatusType from "@irati/wallet/types/enums/Status";
import Card from "@irati/ui/src/Layout/Card";
import authentication from "@irati/auth";
import PrimaryDetails from "../../../PrimaryDetails";
var StyledCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);\n"], ["\n  margin-bottom: 20px;\n  box-shadow: 0 4px 11px 0 rgba(82, 97, 115, 0.18);\n"])));
// TODO show invoice ref number if Bank transfer, need a design
var TopUp = /** @class */ (function (_super) {
    __extends(TopUp, _super);
    function TopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getSubTitle = function () {
            var _a = _this.props, formatMessage = _a.formatMessage, isBankTransfer = _a.isBankTransfer;
            return isBankTransfer ? formatMessage({ id: "wallet.reward.topup.bankTransfer" }) : formatMessage({ id: "wallet.reward.topup.cardPayment" });
        };
        return _this;
    }
    TopUp.prototype.render = function () {
        var _a = this.props, statementItem = _a.statementItem, branding = _a.branding;
        var tenant = authentication.userTenant();
        var currency = authentication.defaultUserCurrency();
        var primaryDetails = {
            image: branding.businessLogoUrl,
            title: tenant.public_name,
            subTitle: this.getSubTitle(),
            amount: statementItem.transfer.amount,
            currency: currency,
            status: StatusType.CLEARED
        };
        var idNamespace = id("top-up", this.props);
        return (React.createElement(StyledCard, { tiny: true, noBorder: true },
            React.createElement(PrimaryDetails, { imgHeightAuto: true, id: idNamespace, data: primaryDetails })));
    };
    TopUp.defaultProps = {
        isBankTransfer: false
    };
    return TopUp;
}(PureComponent));
export default injectIntl(withBranding(TopUp));
var templateObject_1;
